<template>
  <div class="vacancy-card-small__img-wrap">
    <video v-if="image && isVideo(image)"
           :title="createTitleMixin(name, null, true)"
           :alt="createAltMixin(name, null, true)"
           class="vacancy-card-small__img  _video">
      <source :src="image.path"
              :type="image.type">
      Your browser does not support the video tag.
    </video>

    <v-lazy-image v-else-if="image"
                  use-picture
                  :src="image.path"
                  :title="createTitleMixin(name)"
                  :alt="createAltMixin(name)"
                  class="vacancy-card-small__img">
      <source type="image/webp"
              :srcset="image.path_web">
    </v-lazy-image>

    <img v-else
         src="@/assets/img/png/no-photo-placeholder.png"
         :alt="createAltMixin(name + '-placeholder')"
         class="vacancy-card-small__img  _placeholder">
  </div>
</template>

<script>
  import {VIDEOS_MIME_TYPES} from '@/constants/files'

  export default {
    name: 'VacancyCardSmallImage',
    props: {
      image: Object,
      name: String,
    },
    methods: {
      isVideo(file) {
        return VIDEOS_MIME_TYPES.includes(file.type);
      },
    }
  }
</script>

<style lang="less">

</style>